import axios from 'axios'
import { ENTRYPOINT } from '../../../config/entrypoint'
import * as types from './mutation_types'
import { setGenerated, updateCellValue, setAddedToFicheTemplate } from './utils'
import Vue from 'vue'
import FileSaver from 'file-saver'

export const setCurrentFiche = ({ commit }, payload) => {
  commit(types.SET_CURRENT_FICHE, payload)
}

export const setCurrentLigne = ({ commit }, payload) => {
  commit(types.SET_CURRENT_LIGNE, payload)
}

export const setLastFiche = ({ commit }, payload) => {
  commit(types.SET_LAST_FICHE, payload)
}

export const getFicheTableauData = async ({ commit }, projectId) => {
  try {
    commit(types.IS_LOADING_FICHE_ESPACES, true)
    const res = await axios({ url: `${ENTRYPOINT}/api/tableau-surface/onglet/liste/${projectId}/1/1`, method: 'GET' })
    commit(types.SET_FICHE_TABLEAU_DATA, res.data.data.items)
  } catch (err) {
    return err.response.data.message
  } finally {
    commit(types.IS_LOADING_FICHE_ESPACES, false)
  }
}

/* export const getFicheTableaulists = async ({ commit }, projectId) => {
  try {
    const res = await axios({ url: `${ENTRYPOINT}/api/tableau-surface/onglet/projet/${projectId}`, method: 'GET' })
    commit(types.SET_FICHE_TABLEAU_DATA, res.data.data.items)
  } catch (err) {
    return err.response.data.message
  }
} */

export const generateFiche = async ({ commit, state }, payload) => {
  try {
    console.log('2')
    const res = await axios({ url: ENTRYPOINT + '/api/fiche-espace/ajout', data: payload.data, method: 'POST' })
    const updatedRowsInfo = setGenerated(payload.toUpdate, res.data.data)
    await Promise.all(Object.keys(updatedRowsInfo).map(key => axios({ url: ENTRYPOINT + '/api/tableau-surface/onglet/modification/' + key, data: updatedRowsInfo[key], method: 'POST' })))
    commit(types.SET_ESPACE_FICHE, updatedRowsInfo)
    return 'Fiche générée'
  } catch (err) {
    return err.response.data.message
  }
}

export const generateFicheZIP = async ({ commit, state }, payload) => {
  try {
    const res = await axios({ url: ENTRYPOINT + '/api/fiche-espace/telecharge-zip', data: payload.data, method: 'POST' })
    return true
  } catch (err) {
    return false
  }
}

export const generateFicheFusion = async ({ commit, state }, payload) => {
  try {
    const res = await axios({ url: ENTRYPOINT + '/api/fiche-espace/telecharge-fusion', data: payload.data, method: 'POST' })
    return true
  } catch (err) {
    return false
  }
}

export const deleteFiche = async ({ commit, state }, payload) => {
  try {
    await axios({ url: ENTRYPOINT + '/api/fiche-espace/supprime/' + payload.fiche.ficheId, method: 'DELETE' })
    const updatedRowsInfo = setGenerated(payload.toUpdate, payload.fiche, false)
    const onglet = Object.keys(updatedRowsInfo)[0]
    await axios({ url: ENTRYPOINT + '/api/tableau-surface/onglet/modification/' + onglet, data: updatedRowsInfo[onglet], method: 'POST' })
    commit(types.SET_ESPACE_FICHE, updatedRowsInfo)
    return 'Fiche supprimée'
  } catch (err) {
    console.log(err)
    return err.response.data.message
  }
}

export const syncDataValue = ({ commit, state }, payload) => {
  const { onglet } = state.currentFicheData
  const index = state.ficheTableauData.findIndex(el => el.id + '' === onglet + '')
  const newData = updateCellValue(state.ficheTableauData, payload)

  if (payload.headerKey === 'C56') {
    state.ficheTableauData[index].client.type = payload.valeur
  }

  if (payload.headerKey === 'C57') {
    state.ficheTableauData[index].client.nom = payload.valeur
  }

  if (payload.headerKey === 'C58') {
    state.ficheTableauData[index].client.adresse = payload.valeur
  }

  if (payload.headerKey === 'C59') {
    state.ficheTableauData[index].client.complement_adresse = payload.valeur
  }

  if (payload.headerKey === 'C60') {
    state.ficheTableauData[index].client.code_postal = payload.valeur
  }

  if (payload.headerKey === 'C61') {
    state.ficheTableauData[index].client.ville = payload.valeur
  }

  if (payload.headerKey === 'C62') {
    state.ficheTableauData[index].client.pays = payload.valeur
  }

  if (payload.headerKey === 'C63') {
    state.ficheTableauData[index].client.nom_du_contact = payload.valeur
  }

  if (payload.headerKey === 'C64') {
    state.ficheTableauData[index].client.prenom_du_contact = payload.valeur
  }

  if (payload.headerKey === 'C65') {
    state.ficheTableauData[index].client.telephone = payload.valeur
  }

  if (payload.headerKey === 'C66') {
    state.ficheTableauData[index].client.mobile = payload.valeur
  }

  if (payload.headerKey === 'C67') {
    state.ficheTableauData[index].client.email1 = payload.valeur
  }

  if (payload.headerKey === 'C68') {
    state.ficheTableauData[index].client.email2 = payload.valeur
  }

  if (payload.headerKey === 'P01') {
    state.ficheTableauData[index].projectData.nom = payload.valeur
  }

  if (payload.headerKey === 'P02') {
    state.ficheTableauData[index].projectData.typeErp = payload.valeur
  }

  if (payload.headerKey === 'P03') {
    state.ficheTableauData[index].projectData.numeroAffaire = payload.valeur
  }

  if (payload.headerKey === 'P04') {
    state.ficheTableauData[index].projectData.contactNom = payload.valeur
  }

  if (payload.headerKey === 'P05') {
    state.ficheTableauData[index].projectData.contactEmail = payload.valeur
  }

  if (payload.headerKey === 'P06') {
    state.ficheTableauData[index].projectData.contactTel1 = payload.valeur
  }

  if (payload.headerKey === 'P07') {
    state.ficheTableauData[index].projectData.contactTel2 = payload.valeur
  }

  if (payload.headerKey === 'P08') {
    state.ficheTableauData[index].projectData.adresse = payload.valeur
  }

  if (payload.headerKey === 'P09') {
    state.ficheTableauData[index].projectData.complementAdresse = payload.valeur
  }

  if (payload.headerKey === 'P10') {
    state.ficheTableauData[index].projectData.codePostal = payload.valeur
  }

  if (payload.headerKey === 'P11') {
    state.ficheTableauData[index].projectData.ville = payload.valeur
  }

  if (payload.headerKey === 'P12') {
    state.ficheTableauData[index].projectData.typeOperations = payload.valeur
  }

  Vue.set(state.ficheTableauData, index, newData)
}

export const saveFicheEspace = async ({ commit, state }, data) => {
  try {
    const { onglet } = data
    const newData = state.ficheTableauData.find(el => el.id + '' === onglet + '')

    await axios({ url: ENTRYPOINT + '/api/fiche-espace/ajout', data: [data], method: 'POST' })
    await axios({ url: ENTRYPOINT + '/api/tableau-surface/onglet/modification/' + onglet, data: newData, method: 'POST' })

    var client = newData.client
    var payload = {
      client: client.id,
      typeClient: client.type,
      nom: client.nom,
      adresse: client.adresse,
      complementAdresse: client.complement_adresse,
      codePostal: client.code_postal,
      ville: client.ville,
      pays: client.pays,
      contactNom: client.nom_du_contact,
      contactPrenom: client.prenom_du_contact,
      contactTel1: client.telephone,
      contactTel2: client.mobile,
      email1: client.email1,
      email2: client.email2,
      etat: client.etat,
      societe: client.societe
    }

    await axios({ url: ENTRYPOINT + '/api/clients/maj-fiche/' + client.id, data: payload, method: 'POST' })

    delete newData.projectData.typeErp
    delete newData.projectData.typeOperations
    await axios({ url: ENTRYPOINT + '/api/projets/modification/' + newData.projectData.id + '?noTableCreate=1', data: newData.projectData, method: 'POST' })
    return 'Fiche sauvegardée'
  } catch (err) {
    return err.response.data.message
  }
}

export const applyStructureFiche = async ({ commit, state }, payload) => {
  try {
    commit(types.IS_LOADING_FICHE_DATA, true)
    const { selected, data } = payload
    const { onglet } = data

    /** va mettre à jour newData avec les données addedToFiche de la fiche qu'on duplique */
    const newData = state.ficheTableauData.find(el => el.id + '' === onglet + '')
    const addedFrom = newData.rows[data.ligne].colAddedToFiche

    for (var i = 0; i < selected.length; i++) {
      if (typeof selected[i].data === 'undefined') {
        selected[i].data = {}
      }

      selected[i].data.elements = data.data.elements
      newData.rows[selected[i].ligne].colAddedToFiche = addedFrom
    }

    await axios({ url: ENTRYPOINT + '/api/fiche-espace/ajout', data: selected, method: 'POST' })
    await axios({ url: ENTRYPOINT + '/api/tableau-surface/onglet/modification/' + onglet, data: newData, method: 'POST' })
    return 'Modifications effectuées'
  } catch (err) {
    console.log(err)
    return "Erreur lors de l'application de la structure"
  } finally {
    commit(types.IS_LOADING_FICHE_DATA, false)
  }
}

export const loadFiche = async ({ commit, state }, payload) => {
  try {
    let ficheId, ligne
    if (typeof payload === 'object') {
      ficheId = payload.ficheId
      ligne = payload.ligne
    } else {
      ficheId = payload
    }
    console.log('4')
    commit(types.IS_LOADING_FICHE_DATA, true)
    const res = await axios({ url: ENTRYPOINT + `/api/fiche-espace/details/${ficheId}`, method: 'GET' })
    if (ligne != null && `${res.data.data.ligne}` !== `${ligne}`) {
      commit(types.SET_CURRENT_FICHE_DATA, { ...res.data.data, ligne, id: ficheId })
      // await axios({ url: ENTRYPOINT + '/api/fiche-espace/ajout', data: [state.currentFicheData], method: 'POST' })
    } else {
      commit(types.SET_CURRENT_FICHE_DATA, { ...res.data.data, id: ficheId })
    }
  } catch (err) {
    return err.response.data.message
  } finally {
    commit(types.SET_CURRENT_LIGNE, null)
    commit(types.IS_LOADING_FICHE_DATA, false)
  }
}

export const addFicheConteneur = ({ commit }, index) => {
  if (isNaN(index)) {
    commit(types.ADD_CONTENEUR, { type: 'conteneur', style: null, childElements: [] })
  } else {
    commit(types.ADD_CONTENEUR_AFTER, { data: { type: 'conteneur', style: null, childElements: [] }, index: index + 1 })
  }
}

export const deleteFicheConteneur = ({ commit }, index) => {
  commit(types.DELETE_CONTENEUR, index)
}

export const addFicheColonne = ({ commit }, payload) => {
  commit(types.ADD_COLONNE, payload)
}

export const deleteFicheColonne = ({ commit }, payload) => {
  commit(types.DELETE_COLONNE, payload)
}

export const resizeFicheColonne = ({ commit }, payload) => {
  commit(types.RESIZE_COLONNE, payload)
}

export const addFicheColonneElement = ({ commit }, payload) => {
  commit(types.ADD_ELEMENT, payload)
}

export const editFicheColonneTextElement = ({ commit }, payload) => {
  commit(types.TEXT_ELEMENT_EDIT, payload)
}

export const deleteFicheColonneTextElement = ({ commit }, payload) => {
  commit(types.DELETE_ELEMENT, payload)
}

export const setSelectedFiche = ({ commit }, payload) => {
  commit(types.SELECTED_FICHE, payload)
}

export const editFicheColonneDropElement = ({ commit }, payload) => {
  commit(types.DROP_ELEMENT_EDIT, payload)
}

export const setAddedToFiche = ({ commit }, payload) => {
  commit(types.SET_ADDED_TO_FICHE, payload)
}

export const updateColonneOrder = ({ commit }, payload) => {
  commit(types.UPDATE_COLONNE_ORDER, payload)
}

export const updateElementOrder = ({ commit }, payload) => {
  commit(types.UPDATE_ELEMENT_ORDER, payload)
}

export const updateElement = ({ commit }, payload) => {
  commit(types.UPDATE_ELEMENT, payload)
}

export const updateConteneur = ({ commit }, payload) => {
  commit(types.UPDATE_CONTAINER, payload)
}

export const updateColonne = ({ commit }, payload) => {
  commit(types.UPDATE_COLONNE, payload)
}

export const getAllTemplatesFiche = async ({ commit, state }, ongletList) => {
  const res = await Promise.all(ongletList.map(onglet => axios({ url: ENTRYPOINT + `/api/fiche-template/onglet/${onglet}`, method: 'GET' })))
  res.forEach(el => {
    const { ongletId, fichesTemplates } = el.data.data
    commit(types.TEMPLATES_FICHE, { ongletId, data: fichesTemplates })
  })
}

export const loadTemplateData = async ({ commit, state }, id) => {
  const res = await axios({ url: ENTRYPOINT + `/api/fiche-template/${id}`, method: 'GET' })
  const resData = res.data.data
  commit(types.SET_CURRENT_FICHE_DATA, { onglet: resData.ongletId, ligne: resData.id, id: resData.id, nom: resData.nom, data: resData.data })
  const strData = JSON.stringify(state.currentFicheData)
  if (strData.includes('"key":"H1"')) {
    setAddedToFicheTemplate(state.currentFicheData, { headerKey: 'H1', value: true })
  }
  return res
}

export const applyTemplateFiche = async ({ commit, state }, payload) => {
  const { id } = payload
  const res = await axios({ url: ENTRYPOINT + `/api/fiche-template/${id}`, method: 'GET' })
  const resData = res.data.data
  state.currentFicheData.data.elements = resData.data.elements
  commit(types.SET_ADDED_TO_FICHE, { headerKey: resData.data.colAddedToFiche, value: true, erase: true })
}

export const createTemplateFiche = async ({ commit, state }, data) => {
  try {
    await axios({ url: ENTRYPOINT + '/api/fiche-template/ajout', data, method: 'POST' })
    const res = await axios({ url: ENTRYPOINT + `/api/fiche-template/onglet/${data.onglet}`, method: 'GET' })
    const { ongletId, fichesTemplates } = res.data.data
    commit(types.TEMPLATES_FICHE, { ongletId: ongletId, data: fichesTemplates })
    return 'Nouvelle fiche créée'
  } catch (err) {
    return err.response.data.message
  }
}

export const updateFicheTemplate = async ({ commit, state }, payload) => {
  const { onglet, nom, ligne, data } = payload
  try {
    await axios({ url: ENTRYPOINT + '/api/fiche-template/modification/' + ligne, data: { onglet, nom, data }, method: 'POST' }) // ligne == id template fiche
    return 'Fiche sauvegardée'
  } catch (err) {
    return err.response.data.message
  }
}

export const updateFicheNom = async ({ commit }, payload) => {
  const { nom, id, onglet } = payload
  try {
    await axios({ url: ENTRYPOINT + '/api/fiche-template/modification-nom/' + id, data: { nom }, method: 'POST' })
    const res = await axios({ url: ENTRYPOINT + `/api/fiche-template/onglet/${onglet}`, method: 'GET' })
    const { ongletId, fichesTemplates } = res.data.data
    commit(types.TEMPLATES_FICHE, { ongletId: ongletId, data: fichesTemplates })
    return 'Fiche modifiée'
  } catch (err) {
    return err.response.data.message
  }
}

export const deleteTemplateFiche = async ({ commit }, payload) => {
  const { id, onglet } = payload
  try {
    await axios({ url: ENTRYPOINT + '/api/fiche-template/supprime/' + id, method: 'DELETE' })
    const res = await axios({ url: ENTRYPOINT + `/api/fiche-template/onglet/${onglet}`, method: 'GET' })
    const { ongletId, fichesTemplates } = res.data.data
    commit(types.TEMPLATES_FICHE, { ongletId: ongletId, data: fichesTemplates })
    return 'Fiche supprimée'
  } catch (err) {
    return err.response.data.message
  }
}

export const loadTemplatesFiche = async ({ commit, state }) => {
  if (!state.templateId) {
    commit(types.TEMPLATE_ID, localStorage.getItem('template_id'))
  }
  commit(types.IS_LOADING_TEMPLATES_FICHE, true)
  const resp = await axios({ url: ENTRYPOINT + '/api/tableau-surface/onglet/liste/' + state.templateId, method: 'GET' })
  const res = await Promise.all(resp.data.data.items.map(onglet => axios({ url: ENTRYPOINT + `/api/fiche-template/onglet/${onglet.id}`, method: 'GET' })))
  res.forEach(el => {
    const { ongletId, fichesTemplates } = el.data.data
    commit(types.TEMPLATES_FICHE, { ongletId, data: fichesTemplates })
  })
  commit(types.IS_LOADING_TEMPLATES_FICHE, false)
}

export const getFicheEspacesListByOnglet = async ({ commit, state }) => {
  commit(types.IS_LOADING_FICHES, true)
  const { onglet } = state.currentFicheData
  const res = await axios({ url: ENTRYPOINT + '/api/fiche-espace/liste/' + onglet, method: 'GET' })
  commit(types.IS_LOADING_FICHES, false)
  return res.data.data
}

// export const applyStructureFiche = async ({ commit, state }, payload) => {
//   try {
//     commit(types.IS_LOADING_FICHE_DATA, true)
//     const { selected, data } = payload
//     selected.forEach(el => {
//       el.data.elements = data.data.elements
//     })
//     console.log('5')
//     await axios({ url: ENTRYPOINT + '/api/fiche-espace/ajout', data: selected, method: 'POST' })
//     return 'Modifications éfféctuées'
//   } catch (err) {
//     return "Erreur lors de l'application de la structure"
//   } finally {
//     commit(types.IS_LOADING_FICHE_DATA, false)
//   }
// }
export const addDroppedHeader = ({ commit }, payload) => {
  commit(types.ADD_DROPPED_HEADER, payload)
}

export const overwriteDroppedHeader = ({ commit }, payload) => {
  commit(types.OVERWRITE_DROPPED_HEADER, payload)
}

export const addDeletedHeader = ({ commit }, payload) => {
  commit(types.ADD_DELETED_HEADER, payload)
}

export const overwriteDeletedHeader = ({ commit }, payload) => {
  commit(types.OVERWRITE_DELETED_HEADER, payload)
}

export const updateFicheTitle = ({ commit }, payload) => {
  commit(types.UPDATE_FICHE_TITLE, payload)
}

export const deleteFicheEspaces = async ({ commit, state }, payload) => {
  try {
    await axios({ url: ENTRYPOINT + '/api/fiche-espace/supprime/' + payload.ficheId, method: 'DELETE' })
    commit(types.UNSET_GENERATED, payload)
    const updatedData = { ...state.tableauInfo[payload.onglet], donnees: { ...state.tableauData[payload.onglet] } }
    await axios({ url: ENTRYPOINT + '/api/tableau-surface/onglet/modification/' + updatedData.id, data: updatedData, method: 'POST' })
    return 'Fiche supprimée'
  } catch (err) {
    return err.response.data.message
  }
}

export const exportFicheEspace = async ({ commit }, payload) => {
  try {
    const pdf = await axios({ url: ENTRYPOINT + '/fiche-espace/telecharge/' + payload.onglet + '/' + payload.ligne, method: 'GET', responseType: 'blob' })
    FileSaver.saveAs(pdf.data, 'fiche-espace.pdf')
    return true
  } catch (err) {
    return false
  }
}
export const exportAllFicheEspace = async ({ commit }, idProjet) => {
  try {
    const pdf = await axios({ url: ENTRYPOINT + '/fiche-espace/telecharge-tous/' + idProjet, method: 'GET', responseType: 'blob' })
    FileSaver.saveAs(pdf.data, 'fiches-espaces.zip')
    return true
  } catch (err) {
    return false
  }
}

export const uploadImage = async ({ commit, state }, payload) => {
  try {
    const res = await axios({ url: ENTRYPOINT + '/api/image/ajout', data: payload.formData, method: 'POST', headers: { 'Content-Type': 'multipart/form-data' } })
    return res.data.data.url
  } catch (err) {
    return err
  }
}

export const updateImageSrc = ({ commit }, payload) => {
  commit(types.UPDATE_IMAGE_SRC, payload)
}
export const setTableauTemplateId = ({ commit }, payload) => {
  commit(types.TABLEAU_TEMPLATE_ID, payload)
}
// mode invite
export const getInviteFicheTableauData = async ({ commit }, obj) => {
  try {
    commit(types.IS_LOADING_FICHE_ESPACES, true)
    const res = await axios({ url: `${ENTRYPOINT}/invite/tableau-surface/onglet-fiche-partage/liste/${obj.projet}/1/1` + '?invitation=' + obj.invitation, method: 'GET' })
    console.log(res)
    commit(types.SET_FICHE_TABLEAU_DATA, res.data.data)
  } catch (err) {
    return err.response.data.message
  } finally {
    commit(types.IS_LOADING_FICHE_ESPACES, false)
  }
}

export const getInviteFicheTableauDataForSchema = async ({ commit }, projectId) => {
  try {
    commit(types.IS_LOADING_FICHE_ESPACES, true)
    const res = await axios({ url: `${ENTRYPOINT}/invite/tableau-surface/onglet-fiche-for-schema/liste/${projectId}/1/1`, method: 'GET' })
    console.log(res)
    commit(types.SET_FICHE_TABLEAU_DATA, res.data.data)
  } catch (err) {
    return err.response.data.message
  } finally {
    commit(types.IS_LOADING_FICHE_ESPACES, false)
  }
}

export const loadInviteFiche = async ({ commit, state }, payload) => {
  try {
    console.log('load mama')
    let ficheId, ligne
    if (typeof payload === 'object') {
      ficheId = payload.ficheId
      ligne = payload.ligne
    } else {
      ficheId = payload
    }
    commit(types.IS_LOADING_FICHE_DATA, true)
    const res = await axios({ url: ENTRYPOINT + `/invite/fiche-espace/details/${ficheId}` + '?invitation=' + payload.invitation, method: 'GET' })
    if (ligne != null && `${res.data.data.ligne}` !== `${ligne}`) {
      commit(types.SET_CURRENT_FICHE_DATA, { ...res.data.data, ligne, id: ficheId })
      // await axios({ url: ENTRYPOINT + '/api/fiche-espace/ajout', data: [state.currentFicheData], method: 'POST' })
    } else {
      commit(types.SET_CURRENT_FICHE_DATA, { ...res.data.data, id: ficheId })
    }
  } catch (err) {
    return err.response.data.message
  } finally {
    commit(types.SET_CURRENT_LIGNE, null)
    commit(types.IS_LOADING_FICHE_DATA, false)
  }
  /* commit(types.IS_LOADING_FICHE_DATA, true)
  const res = await axios({ url: ENTRYPOINT + `/invite/fiche-espace/details/${ficheId}`, method: 'GET' })
  commit(types.SET_CURRENT_FICHE_DATA, { ...res.data.data, id: ficheId })
  commit(types.IS_LOADING_FICHE_DATA, false) */
}

export const setRowId = ({commit}, payload) => {
  commit(types.SET_ROW_ID, payload)
}



// WEBPACK FOOTER //
// ./src/store/modules/ficheEspace/actions.js